var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvAndroidStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_6206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7416_6206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2262 11.5652C13.7224 11.5652 16.5566 8.949 16.5566 5.72174C16.5566 2.49448 13.7224 -0.121738 10.2262 -0.121738C6.72998 -0.121738 3.89575 2.49448 3.89575 5.72174C3.89575 8.949 6.72998 11.5652 10.2262 11.5652Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 1.00174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0262 4.26085H5.42619C4.58095 4.26085 3.89575 4.94605 3.89575 5.79129V15.3913C3.89575 16.2365 4.58095 16.9217 5.42619 16.9217H15.0262C15.8714 16.9217 16.5566 16.2365 16.5566 15.3913V5.79129C16.5566 4.94605 15.8714 4.26085 15.0262 4.26085Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 1.00174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90213 -1.05685C5.78106 -1.27527 5.85998 -1.55048 6.0784 -1.67155C6.29681 -1.79262 6.57202 -1.7137 6.6931 -1.49529L9.15509 2.94626C9.27616 3.16468 9.19724 3.43989 8.97882 3.56096C8.76041 3.68203 8.4852 3.60312 8.36412 3.3847L5.90213 -1.05685Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8347 7.39132C16.8347 6.46924 17.5822 5.72175 18.5043 5.72175C19.4263 5.72175 20.1738 6.46924 20.1738 7.39132V13.3044C20.1738 14.2264 19.4263 14.9739 18.5043 14.9739C17.5822 14.9739 16.8347 14.2264 16.8347 13.3044V7.39132Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9216 14.1391C10.9216 13.2171 11.6691 12.4696 12.5912 12.4696C13.5133 12.4696 14.2607 13.2171 14.2607 14.1391V20.0522C14.2607 20.9743 13.5133 21.7217 12.5912 21.7217C11.6691 21.7217 10.9216 20.9743 10.9216 20.0522V14.1391Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55 -1.05685C14.6711 -1.27527 14.5922 -1.55048 14.3738 -1.67155C14.1553 -1.79262 13.8801 -1.71371 13.7591 -1.49529L11.2971 2.94626C11.176 3.16468 11.2549 3.43989 11.4733 3.56096C11.6917 3.68203 11.967 3.60311 12.088 3.38469L14.55 -1.05685Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61745 7.39131C3.61745 6.46924 2.86996 5.72175 1.94789 5.72175C1.02581 5.72175 0.27832 6.46924 0.27832 7.39131V13.3044C0.27832 14.2264 1.02581 14.9739 1.94789 14.9739C2.86996 14.9739 3.61745 14.2264 3.61745 13.3044V7.39131Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53054 14.1391C9.53054 13.2171 8.78305 12.4696 7.86097 12.4696C6.9389 12.4696 6.19141 13.2171 6.19141 14.1391V20.0522C6.19141 20.9743 6.9389 21.7217 7.86097 21.7217C8.78305 21.7217 9.53054 20.9743 9.53054 20.0522V14.1391Z",
    fill: "#A4C639",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2262 11.5652C13.7224 11.5652 16.5566 8.949 16.5566 5.72174C16.5566 2.49448 13.7224 -0.121738 10.2262 -0.121738C6.72998 -0.121738 3.89575 2.49448 3.89575 5.72174C3.89575 8.949 6.72998 11.5652 10.2262 11.5652Z",
    fill: "#A4C639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0262 4.26085H5.42619C4.58095 4.26085 3.89575 4.94605 3.89575 5.79129V15.3913C3.89575 16.2365 4.58095 16.9217 5.42619 16.9217H15.0262C15.8714 16.9217 16.5566 16.2365 16.5566 15.3913V5.79129C16.5566 4.94605 15.8714 4.26085 15.0262 4.26085Z",
    fill: "#A4C639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61743 5.96523H16.8348H3.61743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61743 5.96523H16.8348",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30414 3.14785C7.45782 3.14785 7.5824 3.02326 7.5824 2.86958C7.5824 2.71591 7.45782 2.59132 7.30414 2.59132C7.15046 2.59132 7.02588 2.71591 7.02588 2.86958C7.02588 3.02326 7.15046 3.14785 7.30414 3.14785Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.50087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1476 3.14785C13.3013 3.14785 13.4259 3.02326 13.4259 2.86958C13.4259 2.71591 13.3013 2.59132 13.1476 2.59132C12.994 2.59132 12.8694 2.71591 12.8694 2.86958C12.8694 3.02326 12.994 3.14785 13.1476 3.14785Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.50087
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_6206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7416_6206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4522,
    height: 24,
    fill: "white",
    transform: "translate(0 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvAndroidStore);
export default __webpack_public_path__ + "static/media/ctv_android_store.ecf85ce05bd5f8633cb6868af63bb8ef.svg";
export { ForwardRef as ReactComponent };